module.exports = __webpack_public_path__ + "static/img/guide.65f747d4.png";